let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ZA5z")).then(() => parcelRequire('lhFAg'));